import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../../env/env';
import { LogoutService } from './logout.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private baseUrl: string = env.url;

  constructor(
    private http: HttpClient,
    private _logoutService: LogoutService,
    private storage: StorageService
  ) {

  }

  //convert json to form data
  private convertJsonToFormData(data: any): FormData {
    let formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    return formData;
  }
  public login(data: any) {
    return this.http.post(`${this.baseUrl}account/login`, this.convertJsonToFormData(data));
  }


  hasPermission(url: string) {
    let permissions = this.storage.userPermissions;

    if (url.startsWith("/invoice")) {
      return permissions?.invoices?.invoices_list?.view?.value;
    } else if (url.startsWith("/invoice/invoice-details")) {
      return permissions?.invoices?.invoice_page?.view?.value;
    }

    else if (url.startsWith("/related-company")) {
      return permissions?.relatedCompany?.relatedCompany_list?.view?.value;
    }

    else if (url.startsWith("/products")) {
      return permissions?.products?.products_list?.view?.value;
    } else if (url.startsWith("/products/product-details")) {
      return permissions?.products?.product_page?.view?.value;
    }

    else if (url.startsWith("/roles")) {
      return permissions?.roles?.roles_list?.view?.value;
    } else if (url.startsWith("/roles/role-details")) {
      return permissions?.roles?.role_page?.view?.value;
    } else if (url.startsWith("/roles/assign-permissions")) {
      return permissions?.roles?.roles_list?.assign?.value;
    }

    else if (url.startsWith("/users")) {
      return permissions?.users?.users_list?.view?.value;
    } else if (url.startsWith("/users/user-details")) {
      return permissions?.users?.user_page?.view?.value;
    }

    else if (url.startsWith("/download-invoices")) {
      return permissions?.invoices?.download_ZIP_Invoices?.view?.value;
    }

    return true;
  }

  goToTargetPath() {
    const permissions = this.storage.userPermissions;
    if (permissions?.invoices?.invoices_list?.view?.value) {
      return "/invoice";
    } else if (permissions?.relatedCompany?.relatedCompany_list?.view?.value) {
      return "/related-company";
    } else if (permissions?.products?.products_list?.view?.value) {
      return "/products";
    } else if (permissions?.roles?.roles_list?.view?.value) {
      return "/roles";
    } else if (permissions?.users?.users_list?.view?.value) {
      return "/users";
    } else if (permissions?.invoices?.download_ZIP_Invoices?.view?.value) {
      return "/download-invoices";
    }

    alert("You don't have access to the system");
    this._logoutService.logout();
    return '';
  }


}
